import styled from 'styled-components';
import { DropdownItem } from 'reactstrap';
import { useDispatch, useSelector } from 'src/store/store';
import { setIsEditingDescription } from 'src/modules/community/communityAbout/actions';
import { showModal } from 'src/modules/shared/modal/actions';
import i18n from 'src/utils/translate';
import { userHasPermission } from 'src/utils/context';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Section } from 'src/constants/footfall';
import { Permission } from 'src/constants/types';
import { ModalType } from 'src/constants/modalTypes';
import ButtonDropdown from 'src/components/buttons/buttonDropdown';
import { titleMedium } from 'styles-js/mixins/typography';

export default function Title() {
  const dispatch = useDispatch();
  const { contact, description, isEditingDescription, support } = useSelector(({ pages }) => pages.communityAbout);
  const communityName = useSelector(({ context }) => context.currentCommunity?.name);
  const guidelines = useSelector(({ context }) => context.currentCommunity?.guidelines);
  const currentUser = useSelector(({ context }) => context.currentUser);

  return (
    <Container>
      {userHasPermission(currentUser, Permission.ViewAdminMenu) ? (
        <>
          <Text>{i18n.t('About ')}<span className="hidden-xs">{communityName}</span></Text>
          <ButtonDropdown
            ariaLabel="Options"
            color="actions"
            dataTestId="about-actions"
            isRightAligned={true}
          >
            {!isEditingDescription && (
              <DropdownItem onClick={() => {
                dispatch(setIsEditingDescription());
                trackFootfallEvent(Event.CLICKED, {
                  clickType: 'add-or-edit-description',
                  clickMetadata: { section: Section.CommunityAbout },
                });
              }}
              >
                {description ? i18n.t('Edit description') : i18n.t('Add description')}
              </DropdownItem>
            )}
            <DropdownItem onClick={() => {
              dispatch(showModal({ modalType: ModalType.GuidelinesAdd }));
              trackFootfallEvent(Event.CLICKED, {
                clickType: 'add-or-edit-guidelines',
                clickMetadata: { section: Section.CommunityAbout },
              });
            }}
            >
              {guidelines ? i18n.t('Edit guidelines') : i18n.t('Add guidelines')}
            </DropdownItem>
            <DropdownItem onClick={() => {
              dispatch(showModal({ modalType: ModalType.ContactDetails }));
              trackFootfallEvent(Event.CLICKED, {
                clickType: 'add-or-edit-contact',
                clickMetadata: { section: Section.CommunityAbout },
              });
            }}
            >
              {contact ? i18n.t('Edit contact info') : i18n.t('Add contact info')}
            </DropdownItem>
            <DropdownItem onClick={() => {
              dispatch(showModal({ modalType: ModalType.SupportDetails }));
              trackFootfallEvent(Event.CLICKED, {
                clickType: 'add-or-edit-support',
                clickMetadata: { section: Section.CommunityAbout },
              });
            }}
            >
              {support ? i18n.t('Edit support info') : i18n.t('Add support info')}
            </DropdownItem>
          </ButtonDropdown>
        </>
      ) : (
        <Text>{i18n.t('About ')} {communityName}</Text>
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  min-height: 45px;
`;

const Text = styled.h2`
  ${titleMedium};
  margin: 0;
  flex: 1 1 0%;
  @media (${({ theme }) => theme.overScreenSmall}) {
    font-size: 24px;
  }
`;
